import Axios from "axios";
const baseURL = process.env.BARRAMUNDI;

const report = {
    getList(params) {
        return Axios.get(`${baseURL}report/scheduled-reports`, {
            params
        }).then(response => (response ? response.data.response : []));
    },
    get(scheduledReportId) {
        return Axios.get(
            `${baseURL}report/scheduled-reports/${scheduledReportId}`
        ).then(response => response?.data?.response || []);
    },
    getCount() {
        return Axios.get(`${baseURL}report/scheduled-reports-count`).then(
            response => response?.data?.response || []
        );
    },
    create(params) {
        return Axios.post(`${baseURL}report/scheduled-reports`, params).then(
            res => {
                if (res && res.data && res.data.response) {
                    return res.data.response;
                }
                return null;
            }
        );
    },
    update(scheduledReportId, params) {
        return Axios.put(
            `${baseURL}report/scheduled-reports/${scheduledReportId}`,
            params
        ).then(res => {
            if (res && res.data && res.data.response) {
                return res.data.response;
            }
            return null;
        });
    },
    delete(scheduledReportId) {
        return Axios.delete(
            `${baseURL}report/scheduled-reports/${scheduledReportId}`
        ).then(res => {
            if (res && res.data && res.data.response) {
                return res.data.response;
            }
            return null;
        });
    }
};
export default report;
